const paths = {
  dashboard: '/',
  login: '/login',
}

export default paths
